/**
 * WatermillTopicInfo 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * WatermillTopicInfo
 */
export interface WatermillTopicInfo {
  name?: string
  display_name?: string
  table?: string
  offset_table?: string
}

/**
 * WatermillTopicInfo Schema
 */
export const WatermillTopicInfoSchema: SchemaDefinition = {
  properties: {
    name: {
      format: 'string',
      type: 'string',
    },
    display_name: {
      format: 'string',
      type: 'string',
    },
    table: {
      format: 'string',
      type: 'string',
    },
    offset_table: {
      format: 'string',
      type: 'string',
    },
  },
  type: 'object',
}
